import { Injectable } from '@angular/core';

import { AvailableScope, DataErrorStore, ScopeItemState } from './data-error.store';

@Injectable()
export class DataErrorService {
  constructor(private store: DataErrorStore) {}

  updateByScope(scope: AvailableScope, updateState: Partial<ScopeItemState>): void {
    this.store.update(state => ({
      ...state,
      [scope]: {
        ...state[scope],
        ...updateState
      }
    }));
  }

  updateByScopeDefaultConflict(scope: AvailableScope, state: boolean): void {
    this.updateByScope(scope, {
      state,
      title: 'Data Conflict',
      content:
        'There is a data conflict because someone else has edited this playlist ' +
        'since you last loaded it and your last action cannot be saved.',
      linkTitle: 'Please click here to reload the updated state of the playlist.'
    });
  }

  updateByScopeCustomConflict(scope: AvailableScope, state: ScopeItemState): void {
    this.updateByScope(scope, state);
  }
}
